export default __webpack_public_path__ + "static/wClause2-a8a2e0ae0d7b69f3acc1079243f8aa95.gif";